import { mapActions, mapGetters, mapState } from 'vuex'
import PageCompiler from '@edools/page-compiler'

const { panels } = PageCompiler.defaults

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    currentView: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('landing', ['panelCopied']),
    ...mapGetters('landing', ['objectById']),
    current() {
      return this.objectById(this.id)
    },
    parentId() {
      return this.current.path ? this.current.path[this.current.path.length - 1] : null
    },
  },
  methods: {
    ...mapActions('landing', [
      'updateOptions',
      'updatePosition',
      'setActive',
      'addPanel',
      'removePanel',
      'removeWidget',
      'setPanelToCopy',
      'batchAdd',
      'pastePanel',
    ]),
    positionChanged({ moved }) {
      this.updatePosition({
        id: moved.element.id,
        from: moved.oldIndex,
        to: moved.newIndex,
      })
    },
    sizeChanged(child, size) {
      this.updateOptions({
        id: child,
        path: `${this.currentView}.size`,
        value: size,
      })
    },
    batch(type, parentId) {
      this.batchAdd({ parentId, elements: panels[type] })
    },
  },
}
